import { render } from "./training-modal.vue?vue&type=template&id=6afc36a6"
import script from "./training-modal.vue?vue&type=script&lang=js"
export * from "./training-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__